module.exports = __webpack_public_path__ + "media/images/emblems/Le_Mont-sur-Lausanne-coat_of_arms-32f48e58531f5829820c09b18f7f3148.svg";